module.exports = __webpack_public_path__ + "img/icon-box.56a424d1.png";